import React from 'react';
import { Link } from 'react-router-dom';
import { Users } from 'lucide-react';
import { LegalPageLayout, Section, Callout, Bullets } from '@/components/LegalPageLayout';

const UPDATED = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

const CodeOfConduct = () => (
  <LegalPageLayout
    title="Code of Conduct"
    lastUpdated={UPDATED}
    icon={Users}
    testid="conduct-page"
    intro={
      <p>
        This Code of Conduct sets out the standards we expect from everyone who uses Option Wizard. It works
        alongside our{' '}
        <Link to="/acceptable-use" className="text-amber-300 hover:underline underline-offset-4">Acceptable Use Policy</Link>
        {' '}and{' '}
        <Link to="/terms" className="text-amber-300 hover:underline underline-offset-4">Terms of Service</Link>.
      </p>
    }
  >
    <Callout tone="blue" title="Scope note">
      Option Wizard is primarily an individual analysis tool and does not currently offer public community
      features such as forums or user-to-user messaging. Provisions below that reference interaction with other users
      apply only if and when such features are made available. The remaining provisions apply to all use today.
    </Callout>

    <Section title="1. Be Respectful & Lawful">
      <Bullets items={[
        'Use the platform honestly and for its intended, lawful purpose.',
        'Do not engage in harassment, threats, hateful, abusive or discriminatory conduct.',
        'Do not impersonate any person or organization, or misrepresent your affiliation.',
      ]} />
    </Section>

    <Section title="2. No Fraud or Deception">
      <Bullets items={[
        'Do not use the platform to commit fraud or deceive others.',
        'Do not create fake accounts or manipulate trials, subscriptions or entitlements.',
        'Do not make misleading claims using content generated by the platform.',
      ]} />
    </Section>

    <Section title="3. Respect Privacy & Security">
      <Bullets items={[
        'Do not attempt to access other users\u2019 accounts or data.',
        'Do not collect, scrape or publish others\u2019 personal information.',
        'Do not probe, scan or test the security of the platform without authorization.',
      ]} />
    </Section>

    <Section title="4. No Spam or Abuse">
      <Bullets items={[
        'Do not send spam through the contact form or any communication channel.',
        'Do not overload the service with automated or excessive requests.',
      ]} />
    </Section>

    <Section title="5. Community Features (if/when available)">
      <Bullets items={[
        'Treat other users with respect and courtesy.',
        'Do not post unlawful, harmful, harassing or misleading content.',
        'Do not attempt to manipulate or defraud other users.',
      ]} />
    </Section>

    <Section title="6. Reporting Violations">
      <p>
        Report conduct that violates this Code through our{' '}
        <Link to="/contact" className="text-amber-300 hover:underline underline-offset-4">contact form</Link>.
      </p>
    </Section>

    <Section title="7. Enforcement">
      <p>
        We may warn, restrict, suspend or terminate access for violations of this Code, consistent with our Terms of
        Service. Where appropriate, we will consider the context and severity of a violation.
      </p>
    </Section>
  </LegalPageLayout>
);

export default CodeOfConduct;
